type Args = {
	singleInstrumentationID: string;
};

/**
 * This utility function doesn't do much
 * The only reason why this exists is because then we can pass in the singleInstrumentationID and get all the ai attributes, without making typo mistakes
 */
export function getAiAttributes({ singleInstrumentationID }: Args) {
	return {
		aiFeatureName: 'JQL_Debugger',
		userGeneratedAI: 1,
		proactiveAIGenerated: 0,
		isAIFeature: 1,
		singleInstrumentationID,
	};
}
